import type { AgentOutputType } from '../agent';
import type { Handoff } from '../handoff';
import type { SerializedHandoff, SerializedTool } from '../model';
import type { Tool } from '../tool';
import {
  getExplicitFunctionToolNamespace,
  getFunctionToolNamespaceDescription,
} from '../tool-identity';
import type { JsonObjectSchema } from '../types';

export function serializeHandoff<TContext, TOutput extends AgentOutputType>(
  h: Handoff<TContext, TOutput>,
): SerializedHandoff {
  return {
    toolName: h.toolName,
    toolDescription: h.toolDescription,
    inputJsonSchema: h.inputJsonSchema as JsonObjectSchema<any>,
    strictJsonSchema: h.strictJsonSchema,
  };
}

export function serializeTool(tool: Tool<any>): SerializedTool {
  if (tool.type === 'function') {
    const namespace = getExplicitFunctionToolNamespace(tool);
    return {
      type: 'function',
      name: tool.name,
      description: tool.description,
      parameters: tool.parameters as JsonObjectSchema<any>,
      strict: tool.strict,
      ...(namespace ? { namespace } : {}),
      ...(namespace
        ? {
            namespaceDescription: getFunctionToolNamespaceDescription(tool),
          }
        : {}),
    };
  }
  return {
    type: 'hosted_tool',
    name: tool.name,
    providerData: tool.providerData,
  };
}
